<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-form :submit="submitSearch">
          <v-card color="grey-lighten-2">
            <v-card-title>
              Filtro de pesquisa
              <!-- SIM, É ADMIN POIS ESTA VIEW é para ADMINS -->
              <DialogNovoGrupo
                               :user="user"
                               @closed="closedDialog"
                               @updated="updatedCreateEdit"
                               :group="editGroup"
                               :float-right="true"
                               :dialogStatus="dialogCreateEdit" />
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                                v-model="filters.searchText"
                                label="Nome"
                                clearable
                                density="compact"
                                hide-details></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                  <v-select
                            :items="[50, 100, 200, 500]"
                            v-model="filters.itemsPerPage"
                            label="Resultados por página"
                            density="compact"
                            hide-details></v-select>
                </v-col>
              </v-row>
              <v-card-actions>
                <v-btn color="warning" @click="clearFilters()"><v-icon class="mr-2">mdi-broom</v-icon>Limpar
                  pesquisa</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit"><v-icon class="mr-2">mdi-magnify</v-icon>Pesquisar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Grupos
            <v-spacer></v-spacer>
            <!-- <v-text-field
              v-model="searchFilter"
              append-inner-icon="mdi-magnify"
              label="Filtrar resultados"
              clearable
              single-line
              hide-details
            ></v-text-field> -->
          </v-card-title>
          <v-data-table
                        :headers="headers"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{
                $moment(item.created_at).format("DD/MM/YYYY HH:mm")
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <div>
                <v-btn
                       color="primary"
                       icon
                       variant="text"
                       @click="editObject(item)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn
                       color="primary"
                       icon
                       variant="text"
                       @click="$router.push({ name: 'GroupMembers', params: { group_id: item.id } })"><v-icon>mdi-account-multiple</v-icon></v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DialogNovoGrupo from "@/components/DialogNovoGrupo.vue";
import api from '@/services'
export default {
  components: { DialogNovoGrupo },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "Sigla", align: "start", key: "acronym", sortable: true },
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Nome de cadastro", align: "start", key: "legal_person.name", sortable: true },
        { title: "Data de cadastro", key: "created_at", sortable: true },
        { title: "", key: "actions", align: "end", sortable: false },
      ],
      lstObjects: [],
      filters: {
        itemsPerPage: 1,
      },
      editGroup: {},
      dialogCreateEdit: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() { },
  activated() { },
  methods: {
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_groups_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.group
            .list(vm.filters, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data.map(o => {
                if (o.legal_person)
                  o.legal_person['customName'] = o.legal_person.name + " - " + o.legal_person.ssn;
                return o;
              });
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    updatedCreateEdit(object) {
      var vm = this;
      if (object) {
        if (!vm.editGroup?.id) {
          vm.lstObjects.unshift(object);
        }
        vm.editGroup = { ...object };
        if (api.storage.selectedGroup()?.id == object.id) {
          api.storage.selectGroup(object);
        }
        vm.dialogCreateEdit = false;
      }
    },
    closedDialog() {
      var vm = this;
      vm.editGroup = {};
      vm.dialogCreateEdit = false;
    },
    editObject(object) {
      var vm = this;
      vm.editGroup = object;
      console.debug("EDITIN GROUP", object);
      vm.dialogCreateEdit = true;
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_groups_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>